import axios, { AxiosResponse } from 'axios';

// export interface ApiResponse<T = any> {
//   status?: number;
//   data?: T;
//   message?: string;
// }

// export const makeAxiosCall = async <T>(
//   endpoint: string,
//   method: Method = 'GET',
//   data: any = null,
//   headers: Record<string, string> = {}
// ) => {
//   try {
//     const response: AxiosResponse<T> = await axios({
//       url: endpoint,
//       method,
//       data,
//       headers,
//     });

//     return {
//       status: response.status,
//       data: response.data,
//     };
//   } catch (error: any) {
//     if (error.response) {
//       return {
//         status: error.response.status,
//         message: error.response.data || 'Something went wrong',
//       };
//     } else {
//       return {
//         status: 500,
//         message: 'Network Error',
//       };
//     }
//   }
// };

// export const getAxiosErrorMessage = (error: AxiosResponse): string => {
//   return error.data.message ?? error.data ?? 'Something went wrong';
// }

export const getAxiosErrorMessage = (error?: AxiosResponse): string => {
    const data = error?.data as unknown;

    if (typeof data === 'string' && data.trim().length > 0) {
        return data;
    }

    if (typeof data === 'object' && data !== null) {
        if('message' in data) {
            const message = (data as { message?: unknown }).message;
            if (typeof message === 'string' && message.trim().length > 0) {
                return message;
            }
        }

        // check if data has any other useful information
        if (typeof data === 'object' && data !== null) {
            const values = Object.values(data);
            for (const value of values) {
                if (typeof value === 'string' && value.trim().length > 0) {
                    return value;
                }
            }
        }
    }

    return 'Something went wrong';
};

export const s3Axios = axios.create();
